import { appearanceEffect } from 'globalStyle';
import styled from 'styled-components';
import { Box } from '@mui/material';

export const CardStats = styled(Box)`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 14.22px;
  margin-top: 8px 0px 17px 0px;
  @media only screen and (max-width: 430px) {
    font-size: 10px;
    line-height: 12.22px;
    margin-top: 6px 0px 15px 0px;
  }
  @media screen and (min-width: 1920px) {
    font-size: 15px;
    line-height: 15px;
  }
`;

export const AddedDataAmount = styled(Box)`
  font-size: 21px;
  line-height: 20.44px;
  font-weight: 300;
  margin-right: 9px;
  @media only screen and (max-width: 430px) {
    font-size: 18px;
    line-height: 19px;
    font-weight: 300;
    margin-right: 6px;
  }
  @media screen and (min-width: 1920px) {
    font-size: 24px;
    line-height: 24px;
  }
`;
export const AddedDataType = styled(Box)`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #7f8fa4;
  @media only screen and (max-width: 430px) {
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;
    color: #7f8fa4;
  }
  @media screen and (min-width: 1920px) {
    font-size: 17px;
    line-height: 17px;
  }
`;
export const AddedDataUnit = styled(Box)`
  font-size: 16px;
  line-height: 18.96px;
  font-weight: 300;

  @media screen and (min-width: 1920px) {
    font-size: 19px;
    line-height: 19px;
  }
`;
export const InnerCardWrapper = styled(Box)`
  display: flex;
  height: 100%;
  width: 100%;
  padding: 12px;
  justify-content: space-between;
  animation-name: ${appearanceEffect};
  animation-duration: 500ms;
`;
export const LeftColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const UpperRow = styled.div``;
export const BottomRow = styled.div``;
export const RightColumn = styled.div``;

export const CardDiv = styled.div<{
  width: number;
  bigger?: boolean;
  height?: number;
  align?: boolean;
  isMobile?: boolean;
  selectedSystemGroup?: string;
  order?: number;
  isHidden?: boolean;
}>`
  background: ${props => (props.isHidden ? 'transparent' : '#ffffff')};
  border: ${props => (props.isHidden ? 'none' : '1px solid #c5d0de')};
  box-sizing: border-box;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: ${props => props.width}%;

  align-items: ${props => (props.align === undefined ? 'center' : '')};
  margin-bottom: ${props => (props.isMobile === true ? '10px' : '')};
`;
